import axios from "axios";
import authHeader from '../../../authheader'

const EIAPPLICATIONURL = process.env.REACT_APP_APIURL + "/api/IndividualEiApplication";

const getViolation = (applicationId) => {
    return axios.get(`${EIAPPLICATIONURL}/violation`, { headers: authHeader(), params: { applicationId }  });
}
const postViolation = (data) => {
    return axios.post(`${EIAPPLICATIONURL}/violation`, data, { headers: authHeader() });
}
export default {
    getViolation,
    postViolation
}